import Item from './view'
import listComponent from '@/util/proto/listComponent'
import Assign from './partial/assign'
import Review from './partial/review'
import { createDict } from '@/util/dicts'
import global from '@/util/mixin/global'
import { saveFile } from '@/util'

const stateIcon = [
  {value:0 , label:'default'},
  {value:10 , label:'error'},
  {value:20 , label:'warning'},
  {value:30 , label:'processing'},
  {value:40 , label:'processing'},
  {value:50 , label:'success'},
  {value:60 , label:'default'},
]

export default {
  mixins:[global],
  extends: listComponent,
  data() {
    return {
      columns: [
        {
          type: 'selection',
          width: 45,
          align: 'center',
          // fixed:'left',
        },
        {
          title: '安装单编号',
          key: 'installNo',
          minWidth: 160,
        },
        {
          title:'申请单编号',
          key:'standardApplyNo',
          minWidth:160,
        },
        {
          title: '企业名称',
          key: 'companyName',
          minWidth: 120,
        },
        {
          title: '车架号',
          key: 'carFrameNo',
          minWidth: 130,
        },
        {
          title: '车辆品牌',
          key: 'carBrand',
          minWidth: 130,
        },
        {
          title: '车辆类型',
          key: 'carCategoryName',
          minWidth: 130,
        },
        {
          title: '类型',
          key: 'installTypeText',
          minWidth: 130,
        },
        {
          title: '状态',
          key: 'stateText',
          minWidth:150,
          render:(h, {row})=>{
            let more = row.state == 5 ? '('+row.reviewResultText+')' : ''
            return <span>{row.stateText}{more}</span>
          }
        },
        {
          title: '安装站点',
          key: 'repairSiteName',
          minWidth: 130,
        },
        {
          title: '安装人',
          key: 'repairUserName',
          minWidth: 130,
        },
        {
          title: '分配时间',
          key: 'assignDatetimeText',
          minWidth:160
        },
        {
          title: '操作',
          key: 'action',
          width: 180,
          align: 'center',
          fixed:'right',
          render: (h, {row}) => {
            let acts = []
            if(this.$a('std.installation.query')){
              acts.push(<a on-click={()=>this.view(row)}>查看</a>)
            }
            //未分配  或  只分配了站点未分配维修员
            if((this.isAdmin || this.isASS) && (row.state == 0 || (row.state == 1 && !row.repairUserId) ) && this.$a('std.installation.assign')){
              acts.push( <a on-click={()=>this.assign([row.id] , row.repairSiteId)}>分配</a> )
            }

            if(
              (
                this.isAdmin && //系统管理员
                (
                  row.state == 1 || //只分配过企业，
                  row.state == 2 //或者 分配过企业和维修员（相当于状态扭转到审核）
                ) || 
                this.isASS && row.state == 2
              ) && this.$a('std.installation.unassign')
            ){
              acts.push( <a on-click={()=>this.unassign([row.id] , row.repairSiteId)}>取消分配</a> )
            }

            if(this.isAdmin && row.state == 2 && this.$a('std.installation.approval')){
              acts.push( <a on-click={()=>this.review(row.id)}>审核</a> )
            }

            if( row.state == 3 && this.isAC && this.$a('std.installation.confirm')){
              acts.push( <a on-click={()=>this.confirm([row.id])}>确认</a> )
            }
            return this.$utils.link(acts,<Divider type="vertical" />)
          }
        }
      ],
      data: [],
      params: {},
      loading: false,

      searchBoxOptions:{
        quick:{
          default: 'companyName',
          options: [
            { value: 'companyName', label: '企业名称' },
            { value: 'carFrameNo', label: '车架号' },
            { value: 'repairSiteName', label: '分配站点' },
            { value: 'repairUserName', label: '分配人' },
            { value: 'standardApplyNo', label: '申请单号' },
            { value: 'brandName', label: '快递品牌' },
            { value: 'repairUserName', label: '安装人' },
            { value: 'installNo', label: '安装单号' },
            
          ]
        },
        more:[
          { label: '地区', type: 'district', key: 'districtCode' },

          { label: '安装类型', type: 'radio', key: 'installType', values: createDict('stdInstallationType') },
          { label: '安装状态', type: 'radio', key: 'state', values: createDict('stdInstallationState') },
          { label: '安装时间', type: 'date', key: 'dateRange', options:{
            shortcuts:['today','yesterday','week','lastweek','month','lastmonth']
          } },

        ]
      },
    }
  },
  created() {
    this.def = { ...this.params }
    this.search()
  },

  methods: {

    search() {
      let params = { search: { ...this.params }, pageSize: this.page.pageSize, pageNum: this.page.pageNum }
      this.loading = true
      this.$request.stdInstallations(params).then(resp => {
        this.loading = false
        if (!resp.code) {
          this.data = this.$utils.conv(resp.data.list || [], { 'installType': 'stdInstallationType', 'assignDatetime': 'datetime', 'state': 'stdInstallationState','reviewResult':'stdInstallationRejectResult'})

          //站点 和 维修师都没分配，允许批量操作
          // for(let i of this.data){
          //   if( i.state != 0){
          //     i._disabled = true
          //   }
          // }
          this.page.total = resp.data.total || 0
        }
      })
    },

    view(row) {
      this.$refs['item'].init(row.id)
    },

    assign(ids , branchId) {
      this.$dialog({
        title:'分配',
        width:550,
        paddingless:true,
        render:(h)=>{
          return <Assign branchId={branchId} id={ids} />
        },
        onOk:()=>{
          this.search()
        }
      })
    },

    unassign(ids){
      this.$Modal.confirm({
        title:'取消分配',
        content:`确定执行 取消分配操作？`,
        onOk:()=>{
          this.$request.stdInstallationUnassign(ids).then(resp => {
            if (resp.code == 0) {
              this.$Message.success('操作成功')
              this.search()
            } else {
              this.$Message.error(resp.msg)
            }
          })
        }
      })
    },
    confirm(ids){
      this.$Modal.confirm({
        title:'确认安装',
        content:`已选择${ids.length}条安装单，是否执行 确认安装操作？`,
        onOk:()=>{
          this.$request.stdInstallationConfirm(ids).then(resp => {
            if (resp.code == 0) {
              this.$Message.success('操作成功')
              this.search()
            } else {
              this.$Message.error(resp.msg)
            }
          })
        }
      })
      
    },

    review( id ){
      this.$dialog({
        title:'审核',
        width:550,
        paddingless:true,
        render:(h)=>{
          return <Review id={id} />
        },
        onOk:()=>{
          this.search()
        }
      })
    },

    reset() {
      this.params = {}
      this.search()
    },

    handleUpdate() {
      this.search()
    },
    handleSearchChange (v){
      let params = {...v}
      if (params.dateRange) {
        params.startTime = params.dateRange[0]
        params.endTime = params.dateRange[1]
        delete params.dateRange
      }
      this.params = params
      this.search()
    },
    handleExport(selection){
      let search = { ...this.params }

      if( selection && selection.length > 0 ){
        search = { ids:selection.map(i => i.id) }
      }

      return this.$request.stdInstallationExport( search ).then(resp => {
        saveFile(resp)
        return Promise.resolve()
      })
    },
  },
  render() {
    const { searchBoxOptions , reset, handleSearchChange } = this

    const tableScopedSlots = {
      batch:({selection , enable}) => {

        const batchActs = []

        if((this.isAdmin || this.isASS ) && this.$a('std.installation.assign')){
          let validData = selection.filter(i => i.state == 0).map(i => i.id)
          let disabled = validData.length == 0
          batchActs.push( <Button disabled={disabled} type="primary" icon="md-build" on-click={() => this.assign(validData)}>分配</Button> )
        }
        if( this.isAC && this.$a('std.installation.confirm')){
          let validData = selection.filter(i => i.state == 3).map(i => i.id)
          let disabled = validData.length == 0
          batchActs.push( <Button disabled={disabled} style="margin-left:8px;" type="primary" icon="md-build" on-click={() => this.confirm(validData)}>确认安装</Button> )
        }

        if( this.isAdmin && this.$a('std.installation.export')){

          batchActs.push( <sl-download style="margin-left:8px;" icon="md-download" click={() => this.handleExport(selection)}>导出</sl-download> )
        }
        return batchActs
      }
    }
    return (
      <sl-page>
        <div class="page-filter">
          <sl-search-combo option={searchBoxOptions} on-reset={reset} on-search={handleSearchChange }>
          </sl-search-combo>
        </div>
        <div class="pg-bd">
          <sl-table showHeader={true} loading={this.loading} selection-key={false} page={this.page} columns={this.columns} data={this.data} on-change={this.$tableChange} scopedSlots={tableScopedSlots}>
          </sl-table>
        </div>
        <Item ref="item" />
      </sl-page>
    )
  }
}